"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BaseColumn = require("./support/BaseColumn");
var _Tooltip = _interopRequireDefault(require("../../../feedback/tooltip/Tooltip"));
var _jsxRuntime = require("react/jsx-runtime");
var ArrayColumn = function ArrayColumn(_) {
  return null;
};
ArrayColumn.toColumnDef = function (child) {
  var props = child.props;
  var accessorKey = props.accessorKey,
    tooltipRender = props.tooltipRender,
    render = props.render,
    renderLimited = props.renderLimited;
  var renderLimit = props.renderLimit || 1;
  return _objectSpread({}, (0, _BaseColumn.defaultColumnDef)(child.props), {
    id: accessorKey,
    accessorFn: function accessorFn(row) {
      return render(row[accessorKey]);
    },
    cell: function cell(_ref) {
      var row = _ref.row,
        getValue = _ref.getValue;
      var rawValue = row.original[accessorKey];
      var value;
      var tooltipValue;
      if (rawValue.length > renderLimit) {
        value = renderLimited(rawValue.length);
        tooltipValue = tooltipRender(rawValue);
      } else {
        value = getValue();
      }
      return (0, _BaseColumn.styledCell)(child.props, /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: rawValue.length > renderLimit ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
          interactable: false,
          content: tooltipValue,
          children: value
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: value
        })
      }));
    },
    footer: function footer() {
      if (props.footer !== undefined) {
        var value = props.footer;
        return (0, _BaseColumn.styledCell)(child.props, value);
      }
      return null;
    }
  });
};
var _default = exports.default = ArrayColumn;